export const Config={
    // api:"http://localhost:3006"
    api:"https://equipment-rental-portal.onrender.com"
}